import { useTranslation } from 'react-i18next';
import { APP_VERSION, BUILD_ID } from '../features/auth/buildInfo';

export function GitLabIcon({ className = 'w-4 h-4' }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M22.65 14.39L20.61 8.12a.85.85 0 0 0-.31-.41.88.88 0 0 0-.52-.16.89.89 0 0 0-.51.16.85.85 0 0 0-.31.41l-1.89 5.8H6.93l-1.89-5.8a.85.85 0 0 0-.31-.41.88.88 0 0 0-.52-.16.89.89 0 0 0-.51.16.85.85 0 0 0-.31.41L1.35 14.39a.84.84 0 0 0 .3.94l10.05 7.3a.53.53 0 0 0 .6 0l10.05-7.3a.84.84 0 0 0 .3-.94z"
        fill="#FC6D26"
      />
      <path
        d="M22.65 14.39l-2.04-6.27a.85.85 0 0 0-.31-.41.88.88 0 0 0-.52-.16.89.89 0 0 0-.51.16.85.85 0 0 0-.31.41l-1.89 5.8h4.76a.84.84 0 0 1 .31.47z"
        fill="#E24329"
      />
      <path
        d="M1.35 14.39l2.04-6.27a.85.85 0 0 1 .31-.41.88.88 0 0 1 .52-.16.89.89 0 0 1 .51.16.85.85 0 0 1 .31.41l1.89 5.8H1.66a.84.84 0 0 1-.31-.47z"
        fill="#E24329"
      />
      <path d="M12 22.63l5.07-8.24H6.93L12 22.63z" fill="#E24329" />
      <path d="M1.35 14.39a.84.84 0 0 0 .3.94l10.35 7.3-5.07-8.24H1.35z" fill="#FCA326" />
      <path d="M22.65 14.39a.84.84 0 0 1-.3.94L12 22.63l5.07-8.24h5.58z" fill="#FCA326" />
    </svg>
  );
}

export function Footer({ className = '' }: { className?: string }) {
  const { t } = useTranslation();
  const gitlabUrl = 'https://gitlab.com/heroyik/talk2nick';
  const landingUrl = 'https://heroyik.gitlab.io/talk2nick/';
  const privacyUrl = 'https://heroyik.gitlab.io/talk2nick/privacy/';

  return (
    <footer
      className={`flex flex-col items-center gap-2 py-4 px-4 text-center text-xs text-[var(--text-secondary)] ${className}`}
      style={{ paddingBottom: 'max(var(--safe-bottom), 16px)' }}
    >
      <div className="flex flex-wrap items-center justify-center gap-3">
        <a
          href={gitlabUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 font-medium hover:text-[var(--text-primary)] transition-colors"
          title="GitLab Repository"
        >
          <GitLabIcon className="w-4 h-4 shrink-0" />
          <span>GitLab</span>
        </a>
        <span className="opacity-30 select-none">•</span>
        <a
          href={landingUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-[var(--text-primary)] transition-colors"
        >
          {t('footer.about')}
        </a>
        <span className="opacity-30 select-none">•</span>
        <a
          href={privacyUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-[var(--text-primary)] transition-colors"
        >
          {t('footer.privacy')}
        </a>
      </div>

      <div className="inline-flex flex-wrap items-center justify-center gap-1.5 text-[11px] opacity-75">
        <img
          src="/favicon.svg"
          alt="talk2nIcK"
          className="w-3.5 h-3.5 rounded-sm inline-block shrink-0"
        />
        <span className="font-medium text-[var(--text-primary)]">talk2nIcK</span>
        <span className="font-mono text-[var(--accent)] font-semibold">v{APP_VERSION}</span>
        <span className="font-mono opacity-60">({BUILD_ID})</span>
      </div>
    </footer>
  );
}
